// extracted by mini-css-extract-plugin
module.exports = {"carousel":"style_carousel__WjrQb","imageSlide":"style_imageSlide__zmLWq","mapPin":"style_mapPin__11bTT"};